import { selectMimicToken } from '../state/auth.js';
import { selectIdentifiers } from '../state/identification.js';
import { selectLocaleState } from '../state/locale.js';
import { selectScreenHeight, selectScreenWidth } from '../state/screen.js';
import { selectSpoofedCountry, selectSpoofedCurrentPostal, selectSpoofedDma, } from '../state/spoof.js';
export const toHeader = (key, value) => {
    return { key, value };
};
const hasValue = (header) => Boolean(header.value);
export const selectAllHeaders = (state) => {
    return [
        ...selectIdentificationHeaders(state),
        ...selectLocaleHeaders(state),
        ...selectMimicHeaders(state),
        ...selectScreenHeaders(state),
        ...selectSpoofHeaders(state),
    ];
};
export const toHeadersRecord = (headers) => {
    return headers.reduce((record, header) => {
        record[header.key] = header.value;
        return record;
    }, {});
};
export const selectIdentificationHeaders = (state) => {
    const identifiers = selectIdentifiers(state);
    if (identifiers) {
        const headers = [
            toHeader('X-Ad-Id', identifiers.adId),
            toHeader('X-Advertising-Id', identifiers.ssaiAdId),
            toHeader('X-Is-Limited-Ad-Tracking', identifiers.ssaiLimitedAdTracking),
            toHeader('X-Device-Group', identifiers.deviceGroup),
            toHeader('X-Device-Type', identifiers.deviceType),
            toHeader('X-Device-App', identifiers.deviceApp),
            toHeader('X-Device-Brand', identifiers.vendor),
            toHeader('X-Device-Platform', identifiers.devicePlatform),
            toHeader('X-Device-Manufacturer', identifiers.manufacturer),
            toHeader('X-Device-Model', identifiers.deviceModel),
            toHeader('X-Device-Id', identifiers.deviceId),
            toHeader('X-Client-Version', identifiers.clientVersion),
            toHeader('X-Player-Version', identifiers.playerVersion),
            toHeader('X-Profile-Id', identifiers.profileId),
            toHeader('X-Session-Id', identifiers.sessionId),
            toHeader('X-Application-Id', identifiers.applicationId),
            toHeader('X-Os', identifiers.osName),
            toHeader('X-Os-Version', identifiers.osVersion),
            toHeader('X-Browser', identifiers.browserName),
            toHeader('X-Browser-Version', identifiers.browserVersion),
            toHeader('X-Browser-Engine', identifiers.browserEngineName),
            toHeader('X-Browser-Engine-Version', identifiers.browserEngineVersion),
            toHeader('X-Supported-Streaming-Protocols', identifiers.supportedStreamingProtocols),
            toHeader('X-Supported-Codecs-List', identifiers.supportedCodecs),
            toHeader('X-Supported-Audio-Codecs', identifiers.supportedAudioCodecs),
            toHeader('X-DRM-Scheme', identifiers.drmSchemeHeader),
            toHeader('X-Supported-HDRModes-List', identifiers.supportedHdrModes),
            toHeader('X-Timezone-Offset', identifiers.timezoneOffset),
            toHeader('X-Supported-Features', identifiers.supportedFeatures),
            toHeader('X-Accessibility-Enabled', identifiers.accessibility),
            toHeader('X-Appsflyer-Id', identifiers.appsflyerId),
            toHeader('X-App-Source', identifiers.appSource),
            toHeader('X-User-Id', identifiers.userId),
        ];
        return headers.filter(hasValue);
    }
    return [];
};
export const selectVapiHeaders = (state) => {
    const identifiers = selectIdentifiers(state);
    const headers = [toHeader('X-SS-User-Id', identifiers?.springServeUserId)];
    return headers.filter(hasValue);
};
export const selectLocaleHeaders = (state) => {
    const { navigatorPostalCode, language, acceptLanguage, clientIP } = selectLocaleState(state);
    return [
        toHeader('X-Client-Postal', navigatorPostalCode),
        toHeader('X-Preferred-Language', language),
        toHeader('Accept-Language', acceptLanguage),
        toHeader('X-Forwarded-For', clientIP), // used to pass client IP to server side api calls
    ].filter(hasValue);
};
export const selectMimicHeaders = (state) => {
    return [toHeader('X-Mimic-Token', selectMimicToken(state))].filter(hasValue);
};
export const selectScreenHeaders = (state) => {
    const screenHeight = selectScreenHeight(state)?.toString();
    const screenWidth = selectScreenWidth(state)?.toString();
    return [
        toHeader('X-Screen-Height', screenHeight),
        toHeader('X-Screen-Width', screenWidth),
    ].filter(hasValue);
};
export const selectSpoofHeaders = (state) => {
    return [
        toHeader('X-Country-Code3', selectSpoofedCountry(state)),
        toHeader('X-Postal-Code', selectSpoofedCurrentPostal(state)),
        toHeader('X-DMA', selectSpoofedDma(state)),
    ].filter(hasValue);
};
